export default "__VITE_ASSET__oi4qBxYX__"